import React from "react";
import { Link } from "react-router-dom";

const PharmacyCardViews = () => {
  return (
    <section className="dc-haslayout dc-dbsectionspace">
      <div className="row">
        <div className="dc-haslayout dc-jobpostedholder">
          <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
            <div className="dc-insightsitem dc-dashboardbox">
              <span>
                <em className="dcunread-count">0</em>
              </span>
              <figure className="dc-userlistingimg">
                <img
                  src="//css.meddylist.com//wp-content/uploads/2025/02/5356190.png"
                  alt="New Customer Orders"
                />
              </figure>
              <div className="dc-insightdetails">
                <div className="dc-title">
                  <h3>New Customer Orders</h3>
                  <Link to="/pharmacy/orders/new">Click To View</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
            <div className="dc-insightsitem dc-dashboardbox">
              <span>
                <em className="dcunread-count">0</em>
              </span>
              <figure className="dc-userlistingimg">
                <img
                  src="//css.meddylist.com//wp-content/uploads/2019/08/img-21.png"
                  alt="Low Stock Alerts"
                />
              </figure>
              <div className="dc-insightdetails">
                <div className="dc-title">
                  <h3>Low Stock Alerts</h3>
                  <Link to="/pharmacy/inventory/low-stock">Review Items</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
            <div className="dc-insightsitem dc-dashboardbox">
              <figure className="dc-userlistingimg">
                <img
                  src="//css.meddylist.com//wp-content/uploads/2019/10/invoice.png"
                  alt="Today's Sales"
                />
              </figure>
              <div className="dc-insightdetails">
                <div className="dc-title">
                  <h3>₹0.00</h3>
                  <span>Today's Sales</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
            <div className="dc-insightsitem dc-dashboardbox">
              <figure className="dc-userlistingimg">
                <img
                  src="//css.meddylist.com//wp-content/uploads/2019/10/support.png"
                  alt="Prescription Requests"
                />
              </figure>
              <div className="dc-insightdetails">
                <div className="dc-title">
                  <h3>Prescription Requests</h3>
                  <Link to="/pharmacy/prescriptions">Click To Review</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
            <div className="dc-insightsitem dc-dashboardbox">
              <figure className="dc-userlistingimg">
                <img
                  src="//css.meddylist.com//wp-content/uploads/2019/10/invoice.png"
                  alt="Check Your Invoices"
                />
              </figure>
              <div className="dc-insightdetails">
                <div className="dc-title">
                  <h3>Check Your Invoices</h3>
                  <Link to="/pharmacy/invoices">Click To View</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
            <div className="dc-insightsitem dc-dashboardbox">
              <figure className="dc-userlistingimg">
                <img
                  src="//css.meddylist.com//wp-content/uploads/2019/10/list.png"
                  alt="Manage Inventory"
                />
              </figure>
              <div className="dc-insightdetails">
                <div className="dc-title">
                  <h3>Manage Inventory</h3>
                  <Link to="/pharmacy/inventory">Click To Manage</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
            <div className="dc-insightsitem dc-dashboardbox">
              <figure className="dc-userlistingimg">
                <img
                  src="//css.meddylist.com//wp-content/uploads/2019/10/writing.png"
                  alt="Items Out of Stock"
                />
              </figure>
              <div className="dc-insightdetails">
                <div className="dc-title">
                  <h3>0</h3>
                  <span>Items Out of Stock</span>
                  <div>
                    <Link to="/pharmacy/inventory">View Items</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
            <div className="dc-insightsitem dc-dashboardbox">
              <figure className="dc-userlistingimg">
                <img
                  src="//css.meddylist.com//wp-content/uploads/2019/08/img-21.png"
                  alt="Upcoming Expiry"
                />
              </figure>
              <div className="dc-insightdetails">
                <div className="dc-title">
                  <h3>Upcoming Expiry</h3>
                  <Link to="/pharmacy/inventory/expiry">View Items</Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="dc-dashboardbox dc-dashboardtabsholder">
            <div className="dc-dashboardboxtitle">
              <h2>Recent Orders</h2>
            </div>
            <div className="dc-emptydata-holder">
              <div className="dc-emptydata">
                <div className="dc-emptydetails dc-empty-booking dc-emptyholder-sm">
                  <span></span>
                  <em>There are no recent orders.</em>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="dc-dashboardbox dc-dashboardtabsholder">
            <div className="dc-dashboardboxtitle">
              <h2>Top Selling Items</h2>
            </div>
            <div className="dc-emptydata-holder">
              <div className="dc-emptydata">
                <div className="dc-emptydetails dc-empty-booking dc-emptyholder-sm">
                  <span></span>
                  <em>No sales data available.</em>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PharmacyCardViews;
